var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaste(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1500 1500",
    style: {
      enableBackground: "new 0 0 1500 1500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\t.st0{fill:#FFFFFF;stroke:#1D1D1D;stroke-width:12.5;stroke-miterlimit:10;}\t.st1{fill:#FFFFFF;stroke:#39526E;stroke-width:37.5;stroke-linecap:round;stroke-miterlimit:10;}\t.st2{fill:none;stroke:#39526E;stroke-width:50;stroke-miterlimit:10;}\t.st3{fill:#ECA025;}\t.st4{fill:#39526E;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1201,1448.7H306.7c-139.4,0-253.5-114.1-253.5-253.5V300.8c0-139.4,114.1-253.5,253.5-253.5H1201  c139.4,0,253.5,114.1,253.5,253.5v894.4C1454.6,1334.6,1340.5,1448.7,1201,1448.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1201,1448.7H306.7c-139.4,0-253.5-114.1-253.5-253.5V300.8c0-139.4,114.1-253.5,253.5-253.5H1201  c139.4,0,253.5,114.1,253.5,253.5v894.4C1454.6,1334.6,1340.5,1448.7,1201,1448.7z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "294.5,398 437.2,398 437.2,1199.5 1085.2,1199.5 1085.2,401.1 1226.4,401.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 773.8,
    y: 210.6,
    transform: "matrix(0.9966 -8.275177e-02 8.275177e-02 0.9966 -21.9458 72.5548)",
    className: "st3",
    width: 180.9,
    height: 180.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 595.4,
    y: 668.7,
    transform: "matrix(0.9328 -0.3605 0.3605 0.9328 -227.5674 298.3137)",
    className: "st4",
    width: 180.9,
    height: 180.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 847,
    y: 688.1,
    className: "st3",
    width: 180.9,
    height: 180.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504.4,
    y: 924.4,
    transform: "matrix(0.9914 -0.1307 0.1307 0.9914 -127.5502 86.4585)",
    className: "st3",
    width: 180.9,
    height: 180.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 773.8,
    y: 950.9,
    transform: "matrix(0.9328 -0.3605 0.3605 0.9328 -317.3174 381.6204)",
    className: "st4",
    width: 180.9,
    height: 180.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544.6,
    y: 362,
    transform: "matrix(0.833 0.5532 -0.5532 0.833 356.3467 -275.7752)",
    className: "st4",
    width: 180.9,
    height: 180.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 818,
    y: 452.9,
    transform: "matrix(0.9363 0.3513 -0.3513 0.9363 248.7794 -284.4888)",
    className: "st4",
    width: 180.9,
    height: 180.9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaste);
export default __webpack_public_path__ + "static/media/waste.28c52cc0568da1ca96d6bc6e6ab672ac.svg";
export { ForwardRef as ReactComponent };